<template>
	<div class="k-page-content">
		<el-tabs v-model="activeName" class="box-eltab">
			<el-tab-pane label="资源管理" name="first">
				<div class="k-page-common">
					<div class="k-common-header">
						<div class="k-filter-option k-filter-input" style="margin-bottom:0;">
							<el-form :inline="true" :model="searchForm" size="mini" ref="searchForm">
								<el-form-item class="topOne">
									<el-input v-model="searchForm.search_text" placeholder="请填写请输入达人昵称/达人账号/主页链接" clearable
										style="width: 100%;"></el-input>
								</el-form-item>
								<el-form-item label="平台">
									<el-select v-model="searchForm.pid" filterable placeholder="请选择平台" clearable @change="doSearch">
										<el-option v-for="item in options.platform_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="供应商">
									<el-select v-model="searchForm.sid" filterable remote reserve-keyword :remote-method="remoteMethod"
										placeholder="请选择供应商" clearable>
										<el-option v-for="item in options.supplier_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="标签">
									<el-select v-model="searchForm.tag" filterable placeholder="请选择标签" clearable>
										<el-option v-for="item in options.tag_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="价格">
									<el-select v-model="searchForm.price" filterable placeholder="请选择价格" clearable>
										<el-option v-for="item in options.parice_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="粉丝数">
									<el-select v-model="searchForm.fans_num" filterable placeholder="请选择粉丝数" clearable>
										<el-option v-for="item in options.fans_num_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="地区">
									<el-select v-model="searchForm.area" filterable placeholder="请选择地区" clearable>
										<el-option v-for="item in options.area_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="发布形式">
									<el-select v-model="searchForm.type" filterable placeholder="请选择发布形式" clearable>
										<el-option v-for="item in options.klprice_list_options" :key="item.code" :label="item.name"
											:value="item.code">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-button type="primary" icon="el-icon-search" @click="doSearch">查询</el-button>
									<el-button type="primary" icon="el-icon-refresh" @click="reset">重置</el-button>
									<el-button type="plain" icon="el-icon-zoom-in" @click="dialogbatchVisible = true">批量查询</el-button>
								</el-form-item>
							</el-form>
						</div>
					</div>
					<div class="k-common-con k-common-con-resource">
						<div class="k-table-wrapper">
							<div class="resourceHandleTop">
								<el-tabs v-model="activeNameCheck" @tab-click="handleCheckClick">
									<el-tab-pane label="已过审" name='first'></el-tab-pane>
									<el-tab-pane label="审核中" name='second'></el-tab-pane>
								</el-tabs>
								<div class="btn">
									<div class="badge-box">
										<template
											v-if="!searchForm.pid || searchForm.pid == 1 || searchForm.pid == 4 || searchForm.pid == 5 || searchForm.pid == 6 || searchForm.pid == 7 || searchForm.pid == 9 || searchForm.pid == 10">
											<div class="s1 s4"></div>
											<div class="s2">平台展示价</div>
										</template>
										<template
											v-if="!searchForm.pid || searchForm.pid == 1 || searchForm.pid == 4 || searchForm.pid == 6">
											<div class="s3 s4"></div>
											<div class="s2">非平台报价</div>
										</template>
										<template
											v-if="!searchForm.pid || searchForm.pid == 3 || searchForm.pid == 8 || searchForm.pid == 2">
											<div class="s3 s5"></div>
											<div class="s2">资源报价</div>
										</template>
									</div>
									<el-button type="primary" size="mini" @click="addResourceOpen"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/ctresource')">新增资源</el-button>
									<el-button type="primary" plain size="mini" @click="openUploadPrice()" icon="el-icon-plus"
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/uploadpricelist')">批量新增</el-button>
									<el-button plain size="mini"
										v-if="handle && $parent.$parent.isAuthAction('admin/resources/resources/clearturndown')"
										@click="clearTurndown">清空已驳回</el-button>
								</div>
							</div>
							<div class="k-table-con">
								<el-table :data="tableData.data" style="width: 100%" row-key="id" ref="table" v-loading="loading"
									highlight-current-row @sort-change="sortChange">
									<el-table-column prop="pid" label="账号" align="center" min-width="260">
										<template slot-scope="scope">
											<div class="cell-account" @click="detail(scope.row)">
												<div class="icon">
													<img class="icon-big" :src="scope.row.avatar_url" v-if="scope.row.avatar_url">
													<img class="icon-big" src="../../assets/images/admin.png" v-else>
												</div>
												<div class="content">
													<div class="title">
														<img class="icons" :src="scope.row.platform_logo">
														<span>{{ scope.row.name }}({{ scope.row.account_code }})</span>
													</div>
													<div class="area">
														<img class="icons" src="../../assets/images/icon6.png">
														<span>{{ scope.row.area ? scope.row.area : '未知' }}</span>
														<span class="status status20">{{ scope.row.status_txt }} </span>
													</div>
													<div class="tag-box">
														<div class="tag" v-for="(item, index) in scope.row.tags" v-if="scope.row.tags.length > 0">
															{{ item }}</div>
														<div v-if="scope.row.tags.length == 0">暂无标签</div>
													</div>
												</div>
											</div>
										</template>
									</el-table-column>
									<el-table-column prop="id" label="系统ID" align="center" min-width="120">
									</el-table-column>
									<el-table-column prop="fans_num" label="粉丝数(W)" align="center" sortable min-width="120">
									</el-table-column>
									<el-table-column prop="execute_num" label="历史合作次数" align="center" min-width="150">
										<!-- sortable -->
									</el-table-column>
									<el-table-column prop="pid" label="供应商" align="center" min-width="240">
										<template slot-scope="scope">
											<template v-if="scope.row.supplier_list.length > 0">
												<template v-for="(itema, indexa) in scope.row.supplier_list">
													<span class="text-font" v-if="itema.isDefault == '默认供应商'">{{ itema.supplier_name }}</span>
													<img v-if="searchForm.status == 1 && itema.isDefault == '默认供应商'"
														src="../../assets/images/icon7.png" class="supplier-more" alt=""
														@click="editSupplierOpen(scope.row)">
													<div class="yxq" style="font-size: 14px;" v-if="itema.isDefault == '默认供应商'">
														{{ itema.short_name }}</div>
												</template>
												<!-- <div class="yxq">有效期：{{ scope.row.price_validity }}</div> -->
												<div class="yxq">创建时间：{{ scope.row.create_time }}</div>
											</template>
											<template v-else>
												--
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="pid" label="发布方式" align="center" min-width="180">
										<template slot-scope="scope">
											<template v-if="scope.row.price_names.length > 0">
												<div :class="scope.row.price_names.length > 2 ? 'price-box price-box-pad' : 'price-box'">
													<div class="price-box-inner">
														<div v-for="(item, index) in scope.row.price_names" v-if="index < 2">
															<div class="price-cell">
																<div class="p1">{{ item }}</div>
															</div>
														</div>
														<el-popover v-if="scope.row.price_names.length > 2" placement="right" width="370"
															trigger="hover">
															<div class="ressupplier">
																<div class="_row" v-for="(item, index) in scope.row.price_names" :key="index">
																	<div class="str">{{ item }}</div>
																	<div class="dashed"></div>
																	<div class="platform_price"
																		v-if="scope.row.price_list[index].price1 && scope.row.price_list[index].price1.length > 1">
																		<span>{{ scope.row.price_list[index].price1[0] }}</span>
																		<span><i>折</i>{{ scope.row.price_list[index].price1[1] }}</span>
																	</div>
																	<div class="platform_price"
																		v-if="scope.row.price_list[index].price1 && scope.row.price_list[index].price1.length == 1">
																		<span></span>
																		<span>{{ scope.row.price_list[index].price1[0] }}</span>
																	</div>
																	<div class="price"
																		v-if="scope.row.price_list[index].price2 && scope.row.price_list[index].price2.length > 1">
																		<span>{{ scope.row.price_list[index].price2[0] }}</span>
																		<span><i>折</i>{{ scope.row.price_list[index].price2[1] }}</span>
																	</div>
																	<div class="price"
																		v-if="scope.row.price_list[index].price2 && scope.row.price_list[index].price2.length == 1">
																		<span></span>
																		<span>{{ scope.row.price_list[index].price2[0] }}</span>
																	</div>
																	<div class="price2"
																		v-if="scope.row.price_list[index].price3 && scope.row.price_list[index].price3.length > 1">
																		<span>{{ scope.row.price_list[index].price3[0] }}</span>
																		<span><i>折</i>{{ scope.row.price_list[index].price3[1] }}</span>
																	</div>
																	<div class="price2"
																		v-if="scope.row.price_list[index].price3 && scope.row.price_list[index].price3.length == 1">
																		<span></span>
																		<span>{{ scope.row.price_list[index].price3[0] }}</span>
																	</div>
																</div>
															</div>
															<div class="seeMore hoverbtn" slot="reference"> 更多 ></div>
														</el-popover>
													</div>
												</div>
											</template>
											<template v-else>
												--
											</template>
										</template>
									</el-table-column>
									<el-table-column prop="pid" label="价格" align="center" width="400">
										<template slot-scope="scope">
											<template v-if="scope.row.price_list.length > 0">
												<div
													:class="scope.row.price_list && scope.row.price_list.length > 2 ? 'price-box price-box-pad' : 'price-box'">
													<div class="price-box-inner">
														<div v-for="(item, index) in scope.row.price_list" :key="index" v-if="index < 2">
															<div class="price-cell" v-if="item.price3">
																<div class="p4" v-if="item.price3.length > 1">
																	<span>{{ item.price3[0] }}</span>
																	<span><i>折</i>{{ item.price3[1] }}</span>
																</div>
																<div class="p4" v-else>
																	<span></span>
																	<span>{{ item.price3[0] }}</span>
																</div>
															</div>
															<div class="price-cell" v-if="item.price1 && item.price2">
																<div class="p2" v-if="item.price1.length > 1">
																	<span>{{ item.price1[0] }}</span>
																	<span><i>折</i>{{ item.price1[1] }}</span>
																</div>
																<div class="p2" v-else>
																	<span></span>
																	<span>{{ item.price1[0] }}</span>
																</div>
																<div class="p3" v-if="item.price2.length > 1">
																	<span>{{ item.price2[0] }}</span>
																	<span><i>折</i>{{ item.price2[1] }}</span>
																</div>
																<div class="p3" v-else>
																	<span></span>
																	<span>{{ item.price2[0] }}</span>
																</div>
															</div>
															<div class="price-cell" v-if="item.price1 && !item.price2">
																<div class="p5" v-if="item.price1.length > 1">
																	<span>{{ item.price1[0] }}</span>
																	<span><i>折</i>{{ item.price1[1] }}</span>
																</div>
																<div class="p5" v-else>
																	<span></span>
																	<span>{{ item.price1[0] }}</span>
																</div>
															</div>
														</div>
													</div>
												</div>
											</template>
											<template v-else>
												--
											</template>
										</template>
									</el-table-column>
									<!-- v-if='handle' -->
									<el-table-column
										v-if="$parent.$parent.isAuthAction('admin/resources/resources/delresource') || $parent.$parent.isAuthAction('admin/resources/resources/resourcesubmit') || $parent.$parent.isAuthAction('admin/resources/resources/setdiscountbyresource')"
										fixed="right" label="操作" align="center" min-width="100">
										<template slot-scope="scope">
											<el-button :disabled="scope.row.status != 1 && scope.row.status != 3"
												@click="handleTableDelete(scope.row)" type="text" :size="size" class="c-danger"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/delresource')">删除</el-button>
											<el-button :disabled="scope.row.status != 1 && scope.row.status != 3"
												@click="resourceSubmit(scope.row)" type="text" :size="size" class="c-danger"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/resourcesubmit')">提交审批</el-button>
											<el-button :disabled="scope.row.status != 4" @click="openDiscount(scope.row)" type="text"
												:size="size" class="c-danger"
												v-if="$parent.$parent.isAuthAction('admin/resources/resources/setdiscountbyresource')">设置折扣</el-button>
										</template>
									</el-table-column>
								</el-table>
								<el-pagination background ref="pagination" @size-change="handleSizeChange"
									@current-change="handleCurrentChange" :current-page="tableData.page | number"
									:page-size="tableData.pagesize | number" :page-sizes="[15, 30, 50, 100]"
									layout="prev, pager, next, sizes, total" :total="tableData.total | number">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
			</el-tab-pane>
		</el-tabs>
		<!--批量查询在库资源-->
		<el-dialog title="批量查询在库资源" :close-on-click-modal="false" :visible.sync="dialogbatchVisible" width="70%"
			@closed="clearDialogForm">
			<el-form ref="batchForm" :model="batchForm" :rules="rules.batchForm" label-position="top" :size="size"
				label-width="80px" v-loading="searchloading">
				<el-form-item label="搜索类型">
					<el-radio-group v-model="batchForm.type">
						<el-radio-button label="ID">资源ID</el-radio-button>
						<el-radio-button label="NAME">资源名称</el-radio-button>
						<el-radio-button label="URL">主页链接</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="搜索内容" prop="content" v-if="batchForm.type">
					<el-input type="textarea" placeholder="请输入搜索内容,多条搜索内容【回车键】换行输入,最多可100条"
						:autosize="{ minRows: 5, maxRows: 10 }" v-model="batchForm.content" show-word-limit>
					</el-input>
				</el-form-item>
				<el-form-item>
					<el-button :size="size" @click="batchForm.content = ''">清 空</el-button>
					<el-button type="primary" plain :size="size" @click="getInfoByAll('batchForm')">搜 索</el-button>
					<el-button type="primary" v-if="searchDrawer" @click="downloadSearchData">下载<i
							class="el-icon-download el-icon--right"></i></el-button>
				</el-form-item>
				<template v-if="searchDrawer">
					<el-divider>搜索结果</el-divider>
					<el-form-item prop="content">
						<el-table border style="padding: 1px;margin-bottom: 10px;" :data="searchData" height="500"
							:span-method="arraySpanMethod" class="k-dialog-table">
							<el-table-column property="group" label="搜索项" show-overflow-tooltip width="100"></el-table-column>
							<el-table-column property="status" label="查询状态">
								<template slot-scope="scope">
									<el-tag effect="dark" type="danger" :size="size" v-if="scope.row.status == 2">未找到</el-tag>
									<el-tag effect="dark" type="success" :size="size" v-if="scope.row.status == 1">已匹配</el-tag>
								</template>
							</el-table-column>
							<el-table-column property="account_code" label="资源账号">
								<template slot-scope="scope">
									<span><i v-if="scope.row.account_code && scope.row.account_code != '暂无'"
											style="color: #409EFF; cursor: pointer;" class="el-icon-copy-document"
											@click="copyText(scope.row.account_code)"></i>&nbsp;{{ scope.row.account_code }}</span>
								</template>
							</el-table-column>
							<el-table-column property="name" label="资源名称">
								<template slot-scope="scope">
									<span><i v-if="scope.row.name && scope.row.name != '暂无'" style="color: #409EFF; cursor: pointer;"
											class="el-icon-copy-document" @click="copyText(scope.row.name)"></i>&nbsp;{{ scope.row.name
											}}</span>
								</template>
							</el-table-column>
							<el-table-column property="platform_name" label="所属平台">
								<template slot-scope="scope">
									<span style="font-weight: bold;color: #F56C6C;"><i
											v-if="scope.row.platform_name && scope.row.platform_name != '暂无'"
											style="color: #409EFF; cursor: pointer;" class="el-icon-copy-document"
											@click="copyText(scope.row.platform_name)"></i>&nbsp;{{ scope.row.platform_name }}</span>
								</template>
							</el-table-column>
							<el-table-column property="supplier_code" show-overflow-tooltip label="供应商编码">
								<template slot-scope="scope">
									<span><i v-if="scope.row.supplier_code && scope.row.supplier_code != '暂无'"
											style="color: #409EFF; cursor: pointer;" class="el-icon-copy-document"
											@click="copyText(scope.row.supplier_code)"></i>&nbsp;{{ scope.row.supplier_code }}</span>
								</template>
							</el-table-column>
							<el-table-column property="short_name" show-overflow-tooltip label="供应商简称">
								<template slot-scope="scope">
									<span><i v-if="scope.row.short_name && scope.row.short_name != '暂无'"
											style="color: #409EFF; cursor: pointer;" class="el-icon-copy-document"
											@click="copyText(scope.row.short_name)"></i>&nbsp;{{ scope.row.short_name }}</span>
								</template>
							</el-table-column>
							<el-table-column property="supplier_name" show-overflow-tooltip label="默认供应商"></el-table-column>
							<el-table-column property="link" label="主页链接" show-overflow-tooltip width="200">
								<template slot-scope="scope">
									<span><i v-if="scope.row.link && scope.row.link != '暂无'" style="color: #409EFF; cursor: pointer;"
											class="el-icon-copy-document" @click="copyText(scope.row.link)"></i>&nbsp;{{ scope.row.link
											}}</span>
								</template>
							</el-table-column>

							<el-table-column property="execute_num" label="合作次数"></el-table-column>

						</el-table>
					</el-form-item>
				</template>
			</el-form>
		</el-dialog>
		<!--新增资源-->
		<el-drawer custom-class="k-drawer" :visible.sync="addFormVisiable" :wrapperClosable="false"
			:close-on-press-escape="false" direction="rtl" size="60%">
			<el-form :model="addForm" ref="addForm" :size="size" :rules="rules.addForm" label-width="110px"
				v-loading="loading">
				<div class="drawer-header">
					<div class="header-title">
						<span>新增资源</span>
						<i class="el-icon-close k-drawer-close" @click="closeForm"></i>
					</div>
				</div>
				<div class="drawer-content resourceCon">
					<el-steps :active="resource_active" finish-status="success" align-center style="margin-top: 20px;">
						<el-step :title="resource_title"></el-step>
						<el-step title="抓取数据"></el-step>
						<el-step title="供应商信息"></el-step>
						<el-step title="完成"></el-step>
					</el-steps>
					<div class="addBox" v-show="resource_active == 0">
						<el-form-item label="平台:" prop="platform.pid" key='pid'>
							<el-radio-group v-model="addForm.platform.pid" @input="changePlatform()">
								<el-radio :disabled="item.is_choose != 1" :label="item.id"
									v-for="(item, index) in options.platform_options" :key="index">
									<div class="fyRadio">
										<img :src="item.attachment">
										<span class="fyRadioTitle">{{ item.platform_name }}</span>
									</div>
								</el-radio>
							</el-radio-group>
						</el-form-item>
					</div>
					<div class="addBox" v-show="resource_active == 1">
						<div v-for="(item, index) in addForm.data" :key="index">
							<template v-if="item.type == 'input' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
									:key="item.fieldName">
									<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
									</el-input>
								</el-form-item>
							</template>
							<template v-if="item.type == 'textarea' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
									:key="item.fieldName">
									<el-input type="textarea" :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
									</el-input>
								</el-form-item>
							</template>
							<template v-if="item.type == 'link' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
									:key="item.fieldName">
									<div style="display: flex;">
										<div style="flex: 1;padding-right:10px;">
											<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
											</el-input>
										</div>
										<div><el-button type="primary" plain @click="getPlatformData(item)">获取平台数据</el-button></div>
									</div>
								</el-form-item>
							</template>
							<template v-if="item.type == 'select' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'change' }"
									:key="item.fieldName">
									<el-select v-model="item.value" filterable :placeholder="'请选择' + item.fieldDesc" clearable
										style="width: 100%;">
										<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
										</el-option>
									</el-select>
								</el-form-item>
							</template>
							<template v-if="item.type == 'select_area' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'change' }"
									:key="item.fieldName">
									<el-cascader style="width: 100%;" filterable clearable :placeholder="'请选择' + item.fieldDesc"
										v-model="item.value" :options="item.list"></el-cascader>
								</el-form-item>
							</template>
							<template v-if="item.type == 'select_tags' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'data.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'change' }"
									:key="item.fieldName">
									<el-select popper-class="tags" v-model="item.value" multiple filterable
										:placeholder="'请选择' + item.fieldDesc" clearable style="width: 100%;">
										<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
										</el-option>
									</el-select>
								</el-form-item>
							</template>
						</div>
					</div>
					<div class="addBox" v-show="resource_active == 2">
						<!--其他平台没有供应商信息，单独把推荐理由和合作须知放在供应商信息内-->
						<!-- <template v-if="addForm.platform.pid == 10">
						<el-form-item label="推荐理由">
							<el-input
							  type="textarea"
							  placeholder="请输入推荐理由"
							  v-model="addForm.data.argument"
							  clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item label="合作须知">
							<el-input
							  type="textarea"
							  placeholder="请输入推荐理由"
							  v-model="addForm.data.notice"
							  clearable
							>
							</el-input>
						</el-form-item>
					</template>
					<template v-else> -->
						<div v-for="(item, index) in addForm.info" :key="index">
							<template v-if="item.type == 'input' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
									:key="item.fieldName">
									<el-input :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
									</el-input>
								</el-form-item>
							</template>
							<template v-if="item.type == 'textarea' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
									:key="item.fieldName">
									<el-input type="textarea" :placeholder="'请输入' + item.fieldDesc" v-model="item.value" clearable>
									</el-input>
								</el-form-item>
							</template>
							<template v-if="item.type == 'date_range' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: 'blur' }"
									:key="item.fieldName">
									<el-date-picker v-model="item.value" type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
										range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
									</el-date-picker>
								</el-form-item>
							</template>
							<template v-if="item.type == 'select' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, message: '请填写' + item.fieldDesc, trigger: ['change'] }"
									:key="item.fieldName">
									<el-select v-model="item.value" filterable :placeholder="'请选择' + item.fieldDesc" clearable
										style="width: 100%;">
										<el-option v-for="itemc in item.list" :key="itemc.value" :label="itemc.label" :value="itemc.value">
										</el-option>
									</el-select>
								</el-form-item>
							</template>
							<template v-if="item.type == 'price' && item.isShow">
								<el-form-item :label="item.fieldDesc" :prop="'info.' + index + '.value'"
									:rules="{ required: item.isRequired ? true : false, validator: validatePrice(item.list), trigger: ['blur', 'change'] }"
									:key="item.fieldName">
									<div class="kPrice">
										<div class="flex" v-for="(itemc, indexc) in item.list" :key="indexc">
											<div v-for="(itema, indexa) in itemc" :key="indexa">
												<template v-if="itema.type == 'text'">
													<span>{{ itema.fieldName }}</span>
												</template>
												<template v-if="itema.type == 'input'">
													<el-input placeholder="设置金额" v-model="itema.value"></el-input>
												</template>
											</div>
										</div>
									</div>
								</el-form-item>
							</template>
						</div>
						<!-- </template> -->
					</div>
				</div>
				<div class="drawer-footer">
					<el-button type="primary" @click="next()" :size='size' v-show="resource_active < 2">下一步</el-button>
					<el-button @click="prev()" :size='size' v-show="resource_active > 0">上一步</el-button>
					<el-button type="primary" @click="addResource" :size='size' v-show="resource_active == 2">提交</el-button>
					<el-button :size='size' @click="closeForm">取消</el-button>
				</div>
			</el-form>
		</el-drawer>
		<!--修改默认供应商-->
		<el-dialog title="供应商" :close-on-click-modal="false" :visible.sync="editSupplierFormVisiable" v-loading="loading"
			width="60%">
			<el-form :model="editSupplierForm" ref="editSupplierForm" :size="size" label-width="110px">
				<div class="editSupplierBox">
					<div class="options">
						<el-radio-group v-model="editSupplierForm.sid">
							<el-radio :label="item.sid" v-for="(item, index) in options.supplier_options" :key="index">{{
								item.supplier_name }}({{ item.short_name }})</el-radio>
						</el-radio-group>
					</div>
					<div class="info">
						<div class="title" v-for="(item, index) in options.supplier_options" :key="index">{{ item.isDefault }}</div>
					</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="editSupplier" :size='size'>提交</el-button>
				<el-button :size='size' @click="editSupplierFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<el-dialog title="折扣/返点" :close-on-click-modal="false" :visible.sync="dialogDiscountVisible" width="30%"
			v-loading="loading">
			<el-form ref="discountForm" :model="discountForm" :rules="rules.discountForm" :size="size" label-width="80px">
				<p style="margin-bottom:15px;color:red;">注意：设置折扣/返点，设置成功后将只应用于该条资源。</p>
				<el-form-item label="设置类型">
					<el-radio-group v-model="discountForm.type">
						<el-radio-button label="zhekou">折扣</el-radio-button>
						<el-radio-button label="fandian">返点</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="折扣比例" prop="discount" v-if="discountForm.type == 'zhekou'">
					<el-input v-model="discountForm.discount">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
				<el-form-item label="返点比例" prop="point" v-if="discountForm.type == 'fandian'">
					<el-input v-model="discountForm.point">
						<template slot="append">%</template>
					</el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button :size="size" @click="dialogDiscountVisible = false">取 消</el-button>
				<el-button type="primary" :size="size" @click="setDiscount('discountForm')">确 定</el-button>
			</div>
		</el-dialog>
		<!--上传刊例价-->
		<el-dialog title="批量更新刊例价" :close-on-click-modal="false" :visible.sync="priceFormVisiable" v-loading="loading"
			width="40%" @close="xiaohuiData">
			<el-form :model="priceForm" ref="priceForm" :size="size" :rules="rules.priceForm" label-width="130px">
				<div>
					<el-form-item label="平台" prop="platform_id">
						<el-select v-model="priceForm.platform_id" filterable placeholder="请选择平台" clearable @change="getFiels">
							<el-option v-for="item in options.platform_list_options" :key="item.code" :label="item.name"
								:value="item.code" :disabled="isDisabled(item.code)">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="上传文件:" prop="excel_file">
						<el-upload drag ref="upload_excel_file" accept=".xls,.xlsx" action
							:http-request="(file) => { return imggreySuccess(file, 'excel_file_files') }"
							:file-list="uploadForm.excel_file_list"
							:on-remove="(file) => handleRemoveUpload2(file, 'excel_file_list')" :auto-upload="false"
							:on-exceed="limitMessage" :limit='1'>
							<i class="el-icon-upload"></i>
							<div class="el-upload__text" style="font-size: 12px;">将文件拖到此处，或<em>点击上传</em><br /><span>支持 .xls
									.xlsx</span>
							</div>
							<div class="el-upload__tip" slot="tip" v-if="priceForm.platform_id"><a @click="downloadTemplate('price')"
									target="_blank" style="color: #409EFF; font-size: 12px; cursor: pointer;"><i
										class="el-icon-download"></i>
									文件模板下载</a>
							</div>
						</el-upload>
					</el-form-item>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="addPrice()" :size='size'>提交</el-button>
				<el-button :size='size' @click="priceFormVisiable = false">取消</el-button>
			</span>
		</el-dialog>
		<!--错误日志-->
		<el-dialog title="错误提示" :visible.sync="tipsVisible" :close-on-click-modal="false" :close-on-press-escape="false"
			width="70%">
			<div class="k-page-common" style="max-height:calc(100vh - 400px); overflow: auto; height: auto !important;">
				<div class="k-common-con" style="margin: 0; flex:none; display: block;">
					<div class="kBill" style="height: auto;">
						<div class="title" style="color: #F56C6C;">
							<div>批量上传刊例价失败,详情如下...</div>
						</div>
						<div style="padding-top: 10px; border-top: 1px solid #EBEEF5;" v-if="tableData2.length > 0">
							<el-table :data="tableData2" style="width: 100%" row-key="id" border stripe ref="table2"
								highlight-current-row class="k-dialog-table">
								<el-table-column prop="account_code" label="资源账号" min-width="100">
								</el-table-column>
								<el-table-column prop="supplier_code" label="供应商编码" min-width="100">
								</el-table-column>
								<el-table-column prop="supplier_as" label="供应商简称" min-width="80">
								</el-table-column>
								<el-table-column prop="error_msg" label="错误信息" min-width="120">
								</el-table-column>
							</el-table>
						</div>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="tipsVisible = false" :size="size">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import * as XLSX from 'xlsx'
export default {
	props: ['info'],
	data () {
		return {
			tipsVisible: false,
			searchloading: false,
			tableData2: [],
			searchData: [],
			searchDrawer: false,
			dialogDiscountVisible: false,
			dialogbatchVisible: false,
			addFormVisiable: false,
			editFormVisiable: false,
			checkSkVisiable: false,
			priceFormVisiable: false,
			editSupplierFormVisiable: false,
			activeName: 'first',
			activeNameCheck: 'first',
			size: 'mini',
			resource_active: 0,
			resource_title: '选择平台',
			handle: false,//审核中不显示操作栏
			loading: false,
			excelHeader: ['搜索项', '查询状态', '资源账号', '资源名称', '所属平台', '供应商编码', '供应商简称', '默认供应商', '主页链接', '合作次数'],
			options: {
				platform_options: [],//平台下拉
				tags_options: [],//标签列表
				platform_list_options: [],//平台
				supplier_list_options: [],//供应商
				tag_list_options: [],//标签
				parice_list_options: [],//价格
				fans_num_list_options: [],//粉丝数
				area_list_options: [],//地区
				klprice_list_options: [],//发布形式
				supplier_options: [{
					sid: 1
				}, { sid: 2 }]//关联供应商列表
			},
			batchForm: {
				type: 'ID',
				content: ''
			},
			priceForm: {
				file_name: '',
				platform_id: '',
				excel_file: '',
			},
			uploadForm: {
				excel_file_list: [],//银行流水
				excel_file_files: []
			},
			searchForm: {
				search_text: '',
				pid: '',
				sid: '',
				tag: '',
				price: '',
				area: '',
				fans_num: '',
				type: '',
				status: 1
			},
			discountForm: {
				id: '',
				type: 'zhekou',
				discount: '',
				point: ''
			},
			resetSearch: {
				search_text: '',
				pid: '',
				sid: '',
				tag: '',
				price: '',
				area: '',
				fans_num: '',
				type: '',
				status: 1
			},
			addForm: {
				platform: {
					pid: ''
				},
				data: [],
				info: []
			},
			editSupplierForm: {
				id: '',
				sid: ''
			},
			rules: {
				priceForm: {
					'platform_id': [{ required: true, message: '请选择平台', trigger: ['change'] }],
					'excel_file': [
						{
							required: true, validator: (rule, value, callback) => {
								if (this.uploadForm.excel_file_files.length < 1 && this.uploadForm.excel_file_list.length < 1) {
									callback(new Error('请上传文件'));
								} else {
									callback();
								}
							}, trigger: ['change', 'blur']
						}
					]
				},
				discountForm: {
					discount: [
						{ required: true, message: '请填写折扣比例', trigger: ['change'] },
						{
							validator: (rule, value, callback) => {
								const regex = /^(100(\.0{0,2})?|[1-9]?\d(\.\d{1,2})?)$/;
								if (regex.test(value)) {
									// 转换为数字后检查是否在范围内
									const numValue = parseFloat(value);
									if (numValue >= 0 && numValue <= 100) {
										return callback();
									}
								}
								callback(new Error('请输入0.00到100之间的数字，并且最多保留两位小数'));
							}, trigger: 'blur'
						}],// 当失去焦点时触发验证
					point: [
						{ required: true, message: '填写返点比例', trigger: ['change'] },
						{
							validator: (rule, value, callback) => {
								const regex = /^(100(\.0{0,2})?|[1-9]?\d(\.\d{1,2})?)$/;
								if (regex.test(value)) {
									// 转换为数字后检查是否在范围内
									const numValue = parseFloat(value);
									if (numValue >= 0 && numValue <= 100) {
										return callback();
									}
								}
								callback(new Error('请输入0.00到100之间的数字，并且最多保留两位小数'));
							}, trigger: 'blur'
						}], // 当失去焦点时触发验证
				},
				batchForm: {
					'type': [
						{ required: true, message: '请选择搜索类型', trigger: ['change'] }
					],
					'content': [
						{ required: true, message: '请填写搜索内容', trigger: ['change'] }
					]
				},
				addForm: {
					platform: {
						'pid': [
							{ required: true, message: '请选择平台', trigger: ['change'] }
						]
					},
					data: {},
					info: {}
				},
				editSupplierForm: {
					'sid': [
						{ required: true, message: '请选择供应商', trigger: ['change'] }
					]
				}
			},
			tableData: {
				total: 0,
				pagesize: 15,
				page: 1,
				data: []
			},
			uploadForm: {
				file_list: [],//附件
				file_files: []
			},
			formType: 'add'
		}
	},
	computed: {
		isSupper: function () {
			return this.info.views.isSupper
		},
		tableHeight: function () {
			return window.innerHeight - 320;
		}
	},
	mounted: function () {
		//this.handleSearch(this.searchForm);
		this.getChecklist()//获取检索下拉
	},
	methods: {
		// 下载搜索结果
		downloadSearchData () {
			// 1. 把tableData转换成Excel可识别的二维数组（表头+数据）
			const tableArray = [
				this.excelHeader, // 第一行是表头
				...this.searchData.map(row => [row.group, row.status_txt, row.account_code, row.name, row.platform_name, row.supplier_code, row.short_name, row.supplier_name, row.link, row.execute_num]) // 后续行是数据
			]

			// 2. 创建工作簿和工作表
			const workbook = XLSX.utils.book_new()
			const worksheet = XLSX.utils.aoa_to_sheet(tableArray)

			// 3. 配置列宽（可选，让Excel打开列宽自适应）
			worksheet['!cols'] = [
				{ wch: 25 }, // 姓名列宽10
				{ wch: 25 },  // 年龄列宽8
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 },  // 地址列宽25
				{ wch: 25 }  // 地址列宽25
			]

			// 4. 把工作表加入工作簿
			XLSX.utils.book_append_sheet(workbook, worksheet, '资源查询结果')

			// 5. 生成Excel文件并下载
			XLSX.writeFile(workbook, '资源查询结果.xlsx')
		},
		copyText (text) {
			const input = document.createElement('textarea')
			input.value = text
			input.style.position = 'fixed'
			input.style.opacity = '0'
			document.body.appendChild(input)
			input.select()
			try {
				document.execCommand('copy')
				this.$message.success('复制完成')
			} catch (e) {
				this.$message.error('复制失败，请手动复制')
			}
			document.body.removeChild(input)
		},
		clearDialogForm () {
			this.searchDrawer = false
			this.batchForm.type = 'ID'
			this.batchForm.content = ''

		},
		computeSpan () {
			this.spanRules = []
			let sameCount = 1

			for (let i = 0; i < this.searchData.length; i++) {
				const curr = this.searchData[i].group
				const next = this.searchData[i + 1] && this.searchData[i + 1].group;

				// 当前和下一条第一列值相同，计数+1
				if (i < this.searchData.length - 1 && curr === next) {
					sameCount++
				} else {
					// 一组结束：第一条存合并行数，后面全部填0
					this.spanRules.push(sameCount)
					for (let j = 1; j < sameCount; j++) {
						this.spanRules.push(0)
					}
					sameCount = 1
				}
			}
		},
		// 官方数组格式合并方法
		arraySpanMethod ({ row, column, rowIndex, columnIndex }) {
			// 只处理第一列 columnIndex === 0
			if (columnIndex === 0) {
				const rowSpan = this.spanRules[rowIndex]
				if (rowSpan > 0) {
					// 当前行作为合并开头，跨行，1列
					return [rowSpan, 1]
				} else {
					// 中间重复行隐藏单元格
					return [0, 0]
				}
			}
			// 其他列不做合并，直接返回 undefined
		},
		// 根据条件批量查询
		getInfoByAll (form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
					this.searchloading = true
					var query_str = this.batchForm.content
					var query_arr = query_str.split(/\r?\n/)
					query_arr = query_arr.filter(item => item && item.trim());
					if (query_arr.length > 100) {
						this.$message.error('最多支持100个搜索项');
						this.searchloading = false
						return
					}
					this.$api.post('/admin/customers/customer/allsearchresources', { 'type': this.batchForm.type, 'content': query_arr }).then(res => {
						if (res.code == 0) {
							this.searchDrawer = true
							this.$set(this, 'searchData', res.data)
							this.computeSpan()
						} else {
							this.$message.error(res.msg);
						}
						this.searchloading = false
					})
				}
			})
		},
		isDisabled (code) {
			// 如果code在[1,2]中，返回false（不禁用）；否则返回true（禁用）
			return ![1, 4].includes(code)
		},
		xiaohuiData () {
			this.priceForm = {
				file_name: '',
				platform_id: '',
				excel_file: '',
			}
			this.uploadForm = {
				excel_file_list: [],//银行流水
				excel_file_files: []
			}
		},
		//上传刊例价
		addPrice () {
			if (this.$refs.upload_excel_file) {
				this.uploadForm.excel_file_files = []
				this.$refs.upload_excel_file.submit()
			}
			const formData = new FormData()
			for (const key in this.priceForm) {
				if (this.priceForm[key]) {
					formData.append(key, this.priceForm[key]);
				}
			}
			//订单文件
			if (this.uploadForm.excel_file_files.length > 0) {
				this.uploadForm.excel_file_files.forEach(item => {
					formData.append('excel_file', item)
				})
			}
			this.$refs['priceForm'].validate(function (valid) {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/uploadprice', formData).then(res => {
						if (res.code === 0) {
							let error_data = res.data
							// 重新加载表格
							if (error_data.length <= 0) {
								this.priceFormVisiable = false;
								this.handleSearch(this.searchForm);
								this.$message.success('批量更新刊例价成功！');
							} else {
								this.priceFormVisiable = false;
								this.tableData2 = error_data
								this.tipsVisible = true
							}
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			}.bind(this));
		},
		imggreySuccess: function (files, field) {
			this.uploadForm[field].push(files.file)
		},
		handleRemoveUpload2 (file, formobj) {
			this.uploadForm[formobj] = []
		},
		downloadTemplate: function (type) {
			var file_name = ''
			if (type == 'price') {
				file_name = `${this.priceForm.file_name}.xlsx`
			}
			this.$api.get('/admin/customers/export/exporttemplate', { 'file_name': file_name }).then(res => {
				if (res.status == 207) {
					let reader = new FileReader(); // 创建读取文件对象
					reader.readAsText(res.data, 'utf-8'); // 设置读取的数据以及返回的数据类型为utf-8
					reader.addEventListener("loadend", function () { // 
						let res = JSON.parse(reader.result); // 返回的数据
						this.$message.error(res.msg)

					}.bind(this))
				} else {
					// 将Blob转换为URL以便创建一个可下载的链接
					const url = window.URL.createObjectURL(new Blob([res]));
					const link = document.createElement('a');
					link.href = url;
					link.setAttribute('download', file_name); // 设置下载文件名
					document.body.appendChild(link);
					link.click(); // 触发点击下载
					document.body.removeChild(link); // 下载后移除元素
					window.URL.revokeObjectURL(url); // 释放URL对象
					this.tipsVisible = false
				}

			})
		},
		getFiels: function (plateform_id) {
			// 这两个平台目前不支持批量更新刊例价
			let arr_plateform = [2, 8]
			if (arr_plateform.indexOf(plateform_id) != -1) {
				this.$message({
					showClose: true,
					message: '该平台暂不支持批量导入资源',
					type: 'warning'
				})
				this.$set(this.priceForm, 'platform_id', '')
				return
			}
			const item = this.options.platform_list_options.find(item => item.code === plateform_id);
			this.priceForm.file_name = "导入刊例价-" + item['name']
		},
		limitMessage: function (files, fileList) {
			this.$message({
				showClose: true,
				message: `本次选择了 ${files.length} 个文件,超出最大要求数量限制`,
				type: 'warning'
			})
		},
		//上传刊例弹窗打开
		openUploadPrice () {
			this.priceForm.file_name = ''
			this.uploadForm.excel_file_files = []
			this.uploadForm.excel_file_list = []
			this.priceFormVisiable = true
		},
		handleSizeChange (pages) {
			this.tableData.pagesize = pages
			this.handleSearch(this.searchForm, 1);
		},
		setDiscount (form) {
			this.$refs[form].validate((valid) => {
				if (valid) {
					this.loading = true
					this.$api.post('/admin/resources/resources/setdiscountbyresource', this.discountForm).then(res => {
						if (res.code == 0) {
							this.$message.success('设置成功')
							this.dialogDiscountVisible = false
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				}
			})

		},
		// 打开折扣弹窗
		openDiscount (row) {
			this.$api.get('/admin/resources/resources/resourceinfo', { id: row.id }).then(res => {
				if (res.code == 0) {
					this.discountForm = res.data
					this.discountForm.id = row.id
					this.dialogDiscountVisible = true
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		validatePrice (list) {
			return (rule, value, callback) => {
				let returnFor = false
				let checkCost = false
				let bb = []
				list.forEach((element) => {
					// 发现错误状态返回
					if (returnFor) return;
					let aa = []
					element.forEach((item) => {
						// 发现错误状态返回
						if (returnFor) return;
						if (item.type == 'input' && item.value != '' && item.value != '0') {
							aa.push(item.value)
						}
					})
					if (aa.length > 0) {
						aa.forEach((cost) => {
							const pattern = /^\d+(\.\d{1,2})?$/; // 示例正则表达式，验证数字最多两位小数的价格格式
							if (!pattern.test(cost)) {
								// 设置金额报错状态
								checkCost = true
								// 发现错误，直接设置错误状态，不需要向下循环了
								returnFor = true
								return;
							}
						})
						bb.push(1)
					}
				});
				if (checkCost) {
					return callback(new Error('请填写有效价格(金额仅保留两位小数)'));
				}
				// 为空则表示每一条刊例中，没有填写任何数据
				if (bb.length <= 0) {
					return callback(new Error('刊例价至少填写一项！'));
				}
				callback();
			}
		},
		handleSearch: function (params, page, prop, order) {
			this.loading = true;
			var param = Object.assign({}, params);
			param['page'] = page ? page : 1;
			param['pagesize'] = this.tableData.pagesize;
			param['prop'] = prop ? prop : 'id';
			param['order'] = order ? order : 'desc';
			this.$api.get('/admin/resources/resources/resourcelist', param).then(res => {
				if (res.code === 0) {
					this.tableData = res.data;
					if (param.status == 2) {
						this.handle = true
					} else {
						this.handle = false
					}
					this.$nextTick(() => {
						if (this.$refs.table) {
							this.$refs.table.doLayout();
						}
					});
					this.loading = false
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 执行查询
		doSearch () {
			this.handleSearch(this.searchForm)
		},
		// 重置
		reset () {
			this.searchForm = JSON.parse(JSON.stringify(this.resetSearch));
			this.doSearch();
		},
		// 排序
		sortChange (e) {
			var order;
			var prop = e.prop;
			if (e.order == 'ascending') {
				order = 'asc';
			} else if (e.order == 'descending') {
				order = 'desc';
			} else {
				prop = this.resetSearch.prop;
				order = this.resetSearch.order;
			}
			this.handleSearch(this.searchForm, 1, prop, order);
		},
		// 改变当前页 page
		handleCurrentChange (val) {
			this.handleSearch(this.searchForm, val);
		},
		//获取平台下拉
		getPlatformdwna () {
			this.$api.get('/admin/resources/resources/platformdwn').then(res => {
				if (res.code === 0) {
					this.options.platform_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//选择平台
		changePlatform () {
			let pid = this.addForm.platform.pid
			let targetId = this.addForm.platform.pid;
			let foundPlatform = this.options.platform_options.find(option => option.id === targetId);
			if (foundPlatform) {
				this.resource_title = foundPlatform.platform_name;
				this.getFiled(this.addForm.platform.pid)
			}
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
		},
		//获取标签
		getTags () {
			this.$api.get('/admin/resources/resources/getTags').then(res => {
				if (res.code === 0) {
					this.options.tags_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		remoteMethod (query) {
			query = query ? query : '';
			this.$api.get('/admin/resources/resources/supldwn', { type: 1, query: query }).then(res => {
				if (res.code === 0) {
					this.options.supplier_list_options = res.data;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取检索下拉项
		getChecklist () {
			this.$api.get('/admin/resources/resources/checklist').then(res => {
				if (res.code === 0) {
					this.options.area_list_options = res.data.area_list;
					this.options.fans_num_list_options = res.data.fans_num_list;
					this.options.platform_list_options = res.data.platform_list;
					this.options.supplier_list_options = res.data.supplier_list;
					this.options.tag_list_options = res.data.tag_list;
					this.options.parice_list_options = res.data.parice_list;
					this.options.klprice_list_options = res.data.klprice_list;
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取所有字段
		getFiled (param) {
			this.$api.get('/admin/resources/resources/getfiled', { pid: param }).then(res => {
				if (res.code === 0) {
					this.addForm.data = res.data.data
					this.addForm.info = res.data.info
				} else {
					this.$message.error(res.msg);
				}
			})
		},
		//获取平台数据
		getPlatformData (item) {
			this.$api.post(item.action, { pid: this.addForm.platform.pid, link: item.value }).then(res => {
				if (res.code === 0) {
					let actionData = res.data
					for (let i = 0; i < this.addForm.data.length; i++) {
						if (actionData.hasOwnProperty(this.addForm.data[i].fieldName)) {
							this.addForm.data[i].value = actionData[this.addForm.data[i].fieldName];
						}
					}
				} else {
					this.$message.error(res.msg);
				}
			})

		},
		//新增资源弹窗
		addResourceOpen () {
			this.clearAddForm()
			this.resource_title = '选择平台'
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
			this.getPlatformdwna()
			this.addFormVisiable = true;
		},
		// 新增资源
		addResource () {
			this.resource_active = 0
			const params = {
				pid: '',
				data: {},
				info: {
					price: {}
				}
			}
			for (const item of this.addForm.data) {
				params.data[item.fieldName] = item.value;
			}
			this.addForm.info.forEach((item, index) => {
				if (item.type == "price") {
					item.list.forEach((itemc, indexc) => {
						itemc.forEach((itema, indexa) => {
							if (itema.type == 'input') {
								params.info.price[itema.fieldName] = itema.value
							}
						})
					})
				} else {
					params.info[item.fieldName] = item.value
				}
			})
			params.pid = this.addForm.platform.pid
			this.$refs['addForm'].validate(function (valid) {
				if (valid) {
					this.loading = true;
					this.$api.post('/admin/resources/resources/ctresource', params).then(res => {
						if (res.code === 0) {
							// 重新加载表格
							this.searchForm.status = 1
							//   this.activeNameCheck = 'second'
							this.handleSearch(this.searchForm);
							this.$message({
								showClose: true,
								message: '添加成功！',
								type: 'success'
							});
							this.addFormVisiable = false;
						} else {
							this.$message.error(res.msg);
						}
						this.loading = false
					})
				} else {
					this.$message({
						showClose: true,
						message: '请填写正确的信息！',
						type: 'warning'
					});
				}
			}.bind(this));
		},
		clearAddForm () {
			this.addForm = {
				platform: {
				},
				info: {
				},
				data: {
				}
			}
		},
		closeForm () {
			this.resource_active = 0
			this.addFormVisiable = false
			this.clearAddForm()
			this.$nextTick(() => {
				this.$refs['addForm'].clearValidate();
			});
		},
		//下一步
		next () {
			var keys = []
			if (this.resource_active == 0) {
				keys = Object.keys(this.addForm.platform).map(key => `platform.${key}`);
			} else if (this.resource_active == 1) {
				keys = Object.keys(this.addForm.data).map(key => `data.${key}.value`);
			} else if (this.resource_active == 2) {
				keys = Object.keys(this.addForm.info).map(key => `info.${key}.value`);
			}
			const fieldsToValidate = keys; // 需要验证的字段名数组
			var allValid = [];
			fieldsToValidate.forEach(field => {
				this.$refs['addForm'].validateField(field, (err) => {
					// 如果某个字段验证失败，处理错误并决定是否继续验证其他字段
					if (err) {
						allValid.push(1)
						return
					}
				});
			});
			// 所有字段验证完成后，检查allValid的值
			if (allValid.length <= 0) {
				this.$nextTick(() => {
					this.$refs['addForm'].clearValidate();
				});
				this.resource_active++
			}
		},
		//上一步
		prev () {
			if (this.resource_active-- < 1) this.resource_active = 0;
		},
		//打开详情页
		detail (row) {
			this.$router.push({
				name: 'ResourceDetail',
				query: { id: row.id, set_id: 7, type: 'detail' }
			});
		},
		//切换审核状态
		handleCheckClick (tab, event) {
			if (this.activeNameCheck == 'second') {
				this.searchForm.status = 2
			} else {
				this.searchForm.status = 1
			}
			this.handleSearch(this.searchForm)
		},
		//打开修改关联供应商弹窗
		editSupplierOpen (row) {
			this.options.supplier_options = row.supplier_list
			const defaultSupplierSid = this.options.supplier_options.find(
				(supplier) => supplier.isDefault === "默认供应商"
			).sid;
			this.editSupplierForm.sid = defaultSupplierSid
			this.editSupplierForm.id = row.id
			this.editSupplierFormVisiable = true
		},
		//修改关联供应商
		editSupplier () {
			this.loading = true
			this.$api.post('/admin/resources/resources/editrsd', this.editSupplierForm).then(res => {
				if (res.code === 0) {
					// 重新加载表格
					let newData = res.data
					var data = this.tableData.data;
					this.tableData.data.forEach(function (item, index) {
						if (newData.id == item.id) {
							this.$set(this.tableData.data, index, newData)

						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '修改成功！',
						type: 'success'
					});
					this.editSupplierFormVisiable = false;
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		},
		// 删除审核中的资源
		handleTableDelete (row) {
			this.$confirm('此操作将永久删除该资源, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.delete('/admin/resources/resources/delresource', { id: row.id }).then(res => {
					if (res.code === 0) {
						var data = this.tableData.data;
						data.forEach(function (item, index) {
							if (item.id == row.id) {
								this.$delete(data, index);
							} else if (item.children) {
								item.children.forEach(function (value, key) {
									if (value.id == row.id) {
										this.$delete(item.children, key);
									}
								}.bind(this));
							}
						}.bind(this));
						this.$message({
							showClose: true,
							message: '该资源已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//清空已驳回
		clearTurndown () {
			this.$confirm('此操作将永久删除全部已驳回的资源, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(function () {
				this.loading = true;
				this.$api.post('/admin/resources/resources/clearturndown').then(res => {
					if (res.code === 0) {
						this.searchForm.status = 2
						this.handleSearch(this.searchForm)
						this.$message({
							showClose: true,
							message: '已驳回资源已成功删除！',
							type: 'success'
						});
					} else {
						this.$message.error(res.msg);
					}
					this.loading = false
				})
			}.bind(this))
		},
		//提交审批
		resourceSubmit (row) {
			this.loading = true
			this.$api.post('/admin/resources/resources/resourcesubmit', { id: row.id }).then(res => {
				if (res.code === 0) {
					var data = this.tableData.data;
					data.forEach(function (item, index) {
						if (row.id == item.id) {
							this.$set(data[index], 'status_txt', '待审核');
							this.$set(data[index], 'status', 2);
						}
					}.bind(this));
					this.$message({
						showClose: true,
						message: '该资源已进入审批流程，等待审核！',
						type: 'success'
					});
				} else {
					this.$message.error(res.msg);
				}
				this.loading = false
			})
		}
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			if (from.path != '/resourceDetail') {
				vm.reset()
			}
		});
	}
}

</script>
<style lang="scss" scoped>
.resourceCon {
	.addBox {
		margin-top: 60px;
	}

	.fyRadio {
		width: 94px;
		height: 40px;
		background: #fbfbfe;
		border: 1px solid #d7dae2;
		border-radius: 5px;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 20px;
			height: 20px;
			margin-right: 6px;
		}

		.fyRadioTitle {
			font-size: 14px;
			font-weight: 400;
			color: #78859b;
		}
	}

	.el-radio {
		display: inline-flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 20px;
	}
}

.resourceHandleTop {
	position: relative;
	padding-bottom: 20px;
	background-color: #fff;

	.btn {
		position: absolute;
		right: 20px;
		top: 0;
		height: 48px;
		display: flex;
		align-items: center;
	}
}
</style>